"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Calltoaction() {
  return <section data-section-id="1366" id="calltoaction" className="bg-background text-foreground relative overflow-hidden py-44 md:py-56">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden md:flex items-center justify-center select-none">
        <span className="font-serif font-normal leading-none" style={{
        fontSize: "28rem",
        color: "var(--accent-deep-red)",
        opacity: 0.06
      }}>
          AI
        </span>
      </div>

      <div className="relative mx-auto max-w-[920px] px-6 md:px-10 text-center">
        {}
        <div className="flex items-center justify-center gap-4">
          <span className="flex items-center gap-2">
            <span className="inline-block h-px w-10" style={{
            backgroundColor: "var(--accent-deep-red)"
          }} />
            <span className="inline-block h-1 w-1 rounded-lg" style={{
            backgroundColor: "var(--accent-deep-red)"
          }} />
          </span>
          <span className="font-default uppercase" style={{
          color: "var(--accent-deep-red)",
          letterSpacing: "0.22em",
          fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)"
        }}>
            § Visibility Ready
          </span>
          <span className="flex items-center gap-2">
            <span className="inline-block h-1 w-1 rounded-lg" style={{
            backgroundColor: "var(--accent-deep-red)"
          }} />
            <span className="inline-block h-px w-10" style={{
            backgroundColor: "var(--accent-deep-red)"
          }} />
          </span>
        </div>

        {}
        <h2 className="font-default font-bold mt-12 text-foreground" style={{
        fontSize: "clamp(2.75rem, 6.5vw, 6rem)",
        lineHeight: 0.98,
        letterSpacing: "-0.025em"
      }}>
          When AI recommends a pro,{" "}
          <em className="not-italic" style={{
          color: "var(--accent-deep-red)"
        }}>
            be the one it picks.
          </em>
        </h2>

        {}
        <p className="font-default mt-12 text-muted-foreground mx-auto max-w-2xl" style={{
        fontSize: "clamp(0.9375rem, 1.05vw, 1.0625rem)",
        lineHeight: 1.65,
        letterSpacing: "0.005em"
      }}>
          Stop losing leads to competitors who show up in AI search results. We optimize your digital presence to ensure you are the top recommendation for local service seekers.
        </p>

        {}
        <div className="mt-16 flex justify-center gap-4">
          <Button asChild className="group bg-accent-deep-red text-white hover:bg-white hover:text-accent-deep-red border border-transparent hover:border-accent-deep-red uppercase font-default transition-all duration-300 rounded-lg w-full sm:w-auto px-9 py-6 h-auto shadow-lg" style={{
          fontSize: "0.875rem",
          letterSpacing: "0.18em",
          fontWeight: 600
        }}>
            <Link to="/ContactPage">
              <span>Book a call</span>
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-24 font-default uppercase" style={{
        color: "var(--muted-foreground)",
        fontSize: "0.6875rem",
        letterSpacing: "0.18em"
      }}>
          ClearLine — AI Visibility Specialists
        </div>
      </div>
    </section>;
}